export default __webpack_public_path__ + "static/media/happy-school-img2.70d2507e.png";